export const BUTTON_HUMAN_LOADING = 400;
